import { render, staticRenderFns } from "./BgmController.vue?vue&type=template&id=ad602966&scoped=true&"
import script from "./BgmController.vue?vue&type=script&lang=ts&"
export * from "./BgmController.vue?vue&type=script&lang=ts&"
import style0 from "./BgmController.vue?vue&type=style&index=0&id=ad602966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad602966",
  null
  
)

export default component.exports